import { Col, Row } from 'antd';
import styled from 'styled-components';

export const BaseOrganizationDiv = styled.div`
  width: 100%;
  padding: 32px 10vw 12px 10vw;
  border-left: 1px solid rgba(0, 0, 0, 0.15);
  border-top: 1px solid rgba(0, 0, 0, 0.15);
  min-height: 96vh;
`;

export const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const LoadingCol = styled(Col)`
  height: 1rem;
  margin: 2em 0;
`;

export const SearchHeaderRow = styled(Row)`
  justify-content: space-between;
  margin: 16px;
`;

export const SearchInput = styled.div`
  .ant-input {
    width: 250px;
  }
`;

export const AddButton = styled.div`
  .ant-btn {
    margin-left: 8px;
  }
`;

export const ContentContainer = styled.div`
  background-color: #fff;
  padding: 12px;
  margin: 16px;
`;

export const OrganizationsRow = styled(Row)`
  row-gap: 0px;
  margin-right: 8px;
`;

export const OrganizationCol = styled(Col)`
  margin-left: 4px;
`;
